// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".svg-icon[data-v-978a5f26]{height:1em;vertical-align:-.15em;width:1em;fill:currentColor;overflow:hidden}.svg-external-icon[data-v-978a5f26]{background-color:currentColor;display:inline-block;-webkit-mask-size:cover!important;mask-size:cover!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
